import {
  CheckCircleIcon,
  InfoIcon,
  SpinnerGapIcon,
  WarningIcon,
  XCircleIcon,
} from '@phosphor-icons/react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

export function Toaster({
  duration = 3000,
  position = 'top-right',
  ...props
}: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      duration={duration}
      icons={{
        success: <CheckCircleIcon className="size-5" />,
        info: <InfoIcon className="size-5" />,
        warning: <WarningIcon className="size-5" />,
        error: <XCircleIcon className="size-5" />,
        loading: <SpinnerGapIcon className="size-5 animate-spin" />,
      }}
      position={position}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
          '--width': '380px',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          content: 'p-1!',
          icon: 'mx-1!',
          title: 'text-base! font-semibold! leading-tight!',
          toast:
            'py-2.5! group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'text-sm! text-background! font-medium! leading-tight!',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          error:
            'group-[.toaster]:bg-destructive! group-[.toaster]:text-destructive-foreground! group-[.toaster]:border-destructive!',
          success:
            'group-[.toaster]:bg-success! group-[.toaster]:text-success-foreground! group-[.toaster]:border-success!',
          loading:
            'group-[.toaster]:bg-secondary! group-[.toaster]:text-secondary-foreground! group-[.toaster]:border-secondary!',
          info: 'group-[.toaster]:bg-tertiary! group-[.toaster]:text-tertiary-foreground! group-[.toaster]:border-tertiary!',
          warning:
            'group-[.toaster]:bg-warning! group-[.toaster]:text-background! group-[.toaster]:border-warning!',
        },
      }}
      {...props}
    />
  );
}
